import { render, staticRenderFns } from "./Forma28Create.vue?vue&type=template&id=cdcf5cbe&scoped=true&"
import script from "./Forma28Create.vue?vue&type=script&lang=js&"
export * from "./Forma28Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf5cbe",
  null
  
)

export default component.exports